import { ValidationResult } from "@components/WizardCst/types";

export const validateAssociateInitiative = (): ValidationResult => ({
  valid: true,
  errors: {},
});
